import styled from '@emotion/styled';

export default styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  line-height: 0;
  outline: none;
`;
